import StarSVG from "@design-system/ui-icons/vanilla/Star"
import { createIcon } from "../createIcon"

export const StarIcon = createIcon(StarSVG)
